import React, { useRef, useEffect, useContext, useState } from "react";
import { useSelector } from "react-redux";
import { motion, usePresence } from "framer-motion";
import { SocketContext } from "../../app/socket";
import { iconStyle } from "../../utils/generalUtils";
import { BiCheck, BiTrash, BiX } from "react-icons/bi";
import ImageSlider from "../../components/ImageSlider/imageSlider";

function InactiveUserItem({ user, inactiveUserActivate }) {
  const socketContext = useContext(SocketContext);

  const containerRef = useRef(null);
  const nonActiveRef = useRef(null);
  const studentRef = useRef(null);
  const professorRef = useRef(null);
  const parentRef = useRef(null);
  // activeState(nonActiveRef);

  useEffect(() => {
    activeState(nonActiveRef.current);
  }, []);

  const currentUser = useSelector((state) => state.profile.value);

  const selected = "";

  const [isPresent, safeToRemove] = usePresence();
  const transition = {
    type: "spring",
    stiffness: 500,
    damping: 70,
    mass: 5,
    duration: 2,
  };
  const animations = {
    layout: true,
    initial: "in",
    style: {
      position: isPresent ? "relative" : "absolute",
    },
    animate: isPresent ? "in" : "out",
    whileTap: "tapped",
    variants: {
      in: { scale: 1, opacity: 1 },
      out: { scale: 0, opacity: 0, zIndex: -1 },
    },
    onAnimationComplete: () => !isPresent && safeToRemove(),
    transition,
  };

  const activeState = (btnItem) => {
    const btnActive = containerRef.current.getElementsByClassName(
      "js-btn-slide-active"
    )[0];
    let itemBounding = containerRef.current.getBoundingClientRect();
    let btnBounding = btnItem.getBoundingClientRect();

    btnActive.style.opacity = 1;
    btnActive.style.left =
      Math.round(btnBounding.left) - Math.round(itemBounding.left) + "px";
    let width = btnItem.offsetWidth;
    btnActive.style.width = width + "px";
  };

  const buttonClick = (item, btnItem) => {
    nonActiveRef.current.classList.remove("active");
    studentRef.current.classList.remove("active");

    btnItem.current.classList.add("active");
    activeState(btnItem.current);
    setTimeout(() => {
      if (btnItem === studentRef) {
        activateUser("student");
      }
    }, "500");
  };

  const activateUser = (type) => {
    const body = {
      user_id: user.user_id,
      type: type,
      activate: 1,
    };
    user.user_type = type;
    socketContext.socket.emit("updateNotActivatedUsers", body);
    inactiveUserActivate(user);
  };

  const [showDeleteOption, setShowDeleteOptions] = useState(false);

  const deleteInactiveUser = () => {
    const body = {
      user_id: user.user_id,
    };
    socketContext.socket.emit("deleteInactiveUser", body);
  };

  const [studentData, setStudentData] = useState();
  const [imageIsOpen, setImageIsOpen] = useState(false);
  const [activeImage, setActiveImage] = useState();

  const [studentFiles, setStudentFiles] = useState([]);

  useEffect(() => {
    try {
      const temp = [];
      const tempFiles = JSON.parse(user.files);
      tempFiles.map((file) => {
        file.map((fileItem) => {
          temp.push(fileItem);
        });
      });
      setStudentFiles(temp);
    } catch (e) {
      console.log(e);
    }
  }, []);

  const openFile = (image) => {
    setImageIsOpen(true);
    setActiveImage(image);
  };

  const populateFiles = () => {
    return studentFiles.map((image, index) => {
      const lastIndex = image.lastIndexOf("/");
      const imageName = image.substring(lastIndex + 1);
      const fileExtension = image.substring(image.lastIndexOf(".") + 1);
      return (
        <div
          key={"asset__item" + index}
          className={
            "content__files-item " + (fileExtension !== "pdf" ? "img" : "pdf")
          }
          onClick={() => openFile(image)}
          title={imageName}
        >
          {image.substring(image.lastIndexOf(".") + 1) === "pdf" && (
            <img
              alt="pdf document edupal"
              className="card__info-submitted-img"
              src="../../../resources/icons/pdf-icon.png"
            />
          )}
          {image.substring(image.lastIndexOf(".") + 1) !== "pdf" && (
            <img className="card__info-submitted-img img" src={image} />
          )}
        </div>
      );
    });
  };

  return (
    <motion.div {...animations} className="list__item">
      {imageIsOpen ? (
        <div
          onClick={() => setImageIsOpen(false)}
          className={"modal-background show z-index"}
        ></div>
      ) : (
        ""
      )}
      {imageIsOpen ? (
        <ImageSlider assets={studentFiles} activeAsset={activeImage} />
      ) : (
        ""
      )}
      <span className="list__item-name">
        {user.first_name} {user.last_name}
      </span>
      <div className="list__item-details">
        <div className="list__item-details-comments">
          <span>{user.general_comments}</span>
        </div>
        <div className="list__item-details-files">{populateFiles()}</div>
      </div>
      <div className="list__item-wrapper">
        <div
          className={"list__item-controls " + (selected === "" ? "" : "active")}
        >
          <div className="list__item-controls-options">
            <div ref={containerRef} className="container">
              <span
                className="list__item-controls-options__active-state js-btn-slide-active"
                role="presentation"
              ></span>
              <div
                ref={nonActiveRef}
                className="list__item-controls-options-option active"
                onClick={(e) => buttonClick(e, nonActiveRef)}
              >
                <span>Μη Ενεργός</span>
              </div>
              <div
                ref={studentRef}
                className="list__item-controls-options-option"
                onClick={(e) => buttonClick(e, studentRef)}
              >
                <span>Ενεργός</span>
              </div>
            </div>
          </div>
        </div>
        <div className="list__item-delete">
          {!showDeleteOption ? (
            <BiTrash
              size={"25px"}
              color={"#cccccc"}
              style={iconStyle("transparent")}
              onClick={() => setShowDeleteOptions(true)}
            />
          ) : (
            ""
          )}
          {showDeleteOption ? (
            <BiCheck
              size={"25px"}
              color={"#cccccc"}
              style={iconStyle("transparent")}
              onClick={() => deleteInactiveUser()}
            />
          ) : (
            ""
          )}
          {showDeleteOption ? (
            <BiX
              size={"25px"}
              color={"#cccccc"}
              style={iconStyle("transparent")}
              onClick={() => setShowDeleteOptions(false)}
            />
          ) : (
            ""
          )}
        </div>
      </div>
    </motion.div>
  );
}

export default InactiveUserItem;
